import styled, { css } from 'styled-components'
import { Input } from '@sketch/components'
import { ReactComponent as SearchIcon } from '@sketch/icons/img-magnifying-glass-17'

export const SearchContainer = styled.div`
  padding: 4px 6px 4px 4px; /* stylelint-disable-line scales/space */
  position: relative;
  background-color: ${({ theme }) => theme.colors.background.secondary.B};
  border-top: 1px solid ${({ theme }) => theme.colors.border.B};
  border-bottom: 1px solid ${({ theme }) => theme.colors.border.B};

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`

export const StyledSearchIcon = styled(SearchIcon)`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 12px;
  width: 17px;
  height: 17px;
  color: ${({ theme }) => theme.colors.foreground.secondary.D};
`

export const SearchInput = styled(Input)(
  ({ theme }) => css`
    width: 100%;
    height: 24px;
    font-size: ${theme.fontSizes.D};
    background-color: ${({ theme }) => theme.colors.background.secondary.B};

    &[type='search'] {
      /* stylelint-disable-next-line scales/space */
      padding: 0 0 0 29px;
      ::-webkit-search-decoration,
      ::-webkit-search-cancel-button {
        /* stylelint-disable-next-line property-no-vendor-prefix */
        -webkit-appearance: none;
        appearance: none;
      }
    }

    /* Avoid an inset focus ring and background color change */
    &:focus-visible {
      outline: none;
      background-color: ${({ theme }) => theme.colors.background.secondary.B};
    }
  `
)

export const TreeContent = styled.div`
  overflow-y: auto;
  flex: 1;
  padding: 8px 4px;
`

export const VirtualizerWrapper = styled.ul`
  width: 100%;
  position: relative;
  margin: 0;
  padding: 0;
  overflow-x: hidden;
`
